import { playSound, Sound } from '~/assets/sounds';
import { Text } from '~/components/ui/Text';
import { useLayoutDispatch, useLayoutSelector } from '../../redux/hooks';
import {
	setSelectedIndexNext,
	setSelectedIndexPrev,
} from '../../redux/slices/vehicleSelectionSlice';
import { CircularArrowButton } from '../CircularArrowButton';
import {
	StyledContainer,
	StyledIndexLabel,
	StyledSpan,
} from './VehicleListControls.styled';

const VehicleListControls = (props: React.HTMLAttributes<HTMLDivElement>) => {
	const selectedIndex = useLayoutSelector(
		(state) => state.vehicleSelection.selectedIndex,
	);
	const maxIndex = useLayoutSelector(
		(state) => state.vehicleSelection.maxIndex,
	);
	const dispatch = useLayoutDispatch();

	const handlePrevButtonClick = (
		event: React.MouseEvent<HTMLDivElement, MouseEvent>,
	) => {
		dispatch(setSelectedIndexPrev());
		event.preventDefault();
	};

	const handleNextButtonClick = (
		event: React.MouseEvent<HTMLDivElement, MouseEvent>,
	) => {
		dispatch(setSelectedIndexNext());
		event.preventDefault();
	};

	return (
		<StyledContainer {...props}>
			<CircularArrowButton
				direction="left"
				onClick={(e) => {
					handlePrevButtonClick(e);
					playSound(Sound.ClickButton);
				}}
				onMouseEnter={() => playSound(Sound.LinkCursor)}
			/>
			<StyledIndexLabel>
				<Text style={{ fontSize: 16, fontWeight: 700, color: '#ffffff' }}>
					{maxIndex !== 0 ? selectedIndex + 1 : 0}
					<StyledSpan>
						&#160;/&#160;{maxIndex !== 0 ? maxIndex + 1 : 0}
					</StyledSpan>
				</Text>
			</StyledIndexLabel>
			<CircularArrowButton
				direction="right"
				onClick={(e) => {
					handleNextButtonClick(e);
					playSound(Sound.ClickButton);
				}}
				onMouseEnter={() => playSound(Sound.LinkCursor)}
			/>
		</StyledContainer>
	);
};

export { VehicleListControls };
